























































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import * as Reveal from '@/assets/scripts/RevealOnScrollModule'
import * as dropdownModule from '@/assets/scripts/DropdownModule'
import * as clickHandlerModule from '@/assets/scripts/ClickHandlerModule'

@Component
export default class Home extends Vue {
	data() {
		return {
			title: "Custom dropdown"
		}
	}
	mounted() {
		new Reveal.revealOnScrollModule()
		new dropdownModule.Dropdown()
		new clickHandlerModule.ClickHandler()
	}
}
